import axios from "axios";

export function apiGetPublications(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/publications" +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetPublication(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/publications/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSavePublication(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/publications", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdatePublication(idPublication, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/publications/" + idPublication, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdatePublications(formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/publications/multiple", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeletePublication(idPublication) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/publications/" + idPublication)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
